import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProductType } from '../../models';
import { EquipmentService } from './equipment.service';
import { ProfileService } from './profile.service';
import { FiltersService } from 'src/app/filters/filters.service';
import { MetricsService } from './metrics.service';
import { DefaultsService } from './defaults.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService extends MetricsService {
  isSearching: boolean = false;
  searchResults?: Array<ProductType> = undefined;
  searchResultsLoaded = new Subject<Array<ProductType> | undefined>();

  constructor(
    public http: HttpClient,
    public profileService: ProfileService,
    public translateService: TranslateService,
    public equipmentService: EquipmentService,
    protected filtersService: FiltersService,
    protected defaultsService: DefaultsService,
    protected authenticationService: AuthenticationService
  ) {
    super(
      translateService,
      filtersService,
      defaultsService,
      authenticationService
    );
  }

  clearSearchResults = () => {
    this.searchResults = undefined;
    this.isSearching = false;
    this.searchResultsLoaded.next(undefined);
  };

  search = (searchTerm: string) => {
    this.isSearching = true;
    const body = this.getMetricsPostBody(
      this.profileService.getSelectedCustomersIds(),
      this.profileService.getSelectedBranchIds(),
      this.profileService.getSelectedRegionIds()
    );
    body.searchFor = searchTerm;
    body.pageSize = 10;
    this.searchResults = undefined;
    this.searchResultsLoaded.next(this.searchResults);

    const url = `${environment.metricsApiUrl}/mobile-metrics/product-types`;

    body.filters.and.push({ in: [searchTerm, { var: 'product_type_name' }] });

    this.http.post<Array<ProductType>>(url, body).subscribe((results) => {
      this.searchResults = results;
      this.equipmentService.sortProductTypes(this.searchResults);
      this.isSearching = false;
      this.searchResultsLoaded.next(this.searchResults);
    });
  };
}
